module.exports = __webpack_public_path__ + "img/1x1_ad.984e9463.png";